// Copyright 2024 Sorama B.V.

import { PLATFORM } from "aurelia-pal";
import { GuidanceTopicType, IGuidanceTopic } from "catalogs/GuidanceCatalog";
import { WorkflowModuleType } from "libraries/WorkflowFramework/Interfaces/IWorkflowModuleConfig";
import { ProductSoundDesignWorkflowModes } from "services/WorkflowModes/WorkflowModes";

export class PsychoacousticsGuidanceCatalog {
    static PsychoacousticsOverviewModule: IGuidanceTopic = {
        name: "Psychoacoustics_Overview",
        modulePath: PLATFORM.moduleName("guidance/Psychoacoustics/Overview.html"),
        title: "Psychoacoustics",
        moduleType: WorkflowModuleType.Help,
        relevantWorkflowModes: ProductSoundDesignWorkflowModes,
        topicType: GuidanceTopicType.TopicOverview,
        topicContent: "Psychoacoustics Help",
    };
    static PsychoacousticsGS1Module: IGuidanceTopic = {
        name: "Psychoacoustics_Q1", //https://sorama.atlassian.net/wiki/spaces/POR/pages/3768680449/Q1+What+is+Psychoacoustics
        modulePath: PLATFORM.moduleName("guidance/Psychoacoustics/Q1WhatIsPsychoacoustics.html"),
        title: "Guidelines for Psychoacoustic Analysis",
        moduleType: WorkflowModuleType.Help,
        relevantWorkflowModes: ProductSoundDesignWorkflowModes,
        topicParent: PsychoacousticsGuidanceCatalog.PsychoacousticsOverviewModule,
        topicType: GuidanceTopicType.Question,
        topicContent: "What is Psychoacoustic Analysis?",
        catchwords: ["psychoacoustics", "measurement", "analysis", "setup", "guidelines"],
    };
    static PsychoacousticsGS2Module: IGuidanceTopic = {
        name: "Psychoacoustics_Q2", //https://sorama.atlassian.net/wiki/spaces/POR/pages/3768680449/Q1+What+is+Psychoacoustics
        modulePath: PLATFORM.moduleName("guidance/Psychoacoustics/Q2HowToSetUpForPsychoacousticsAnalysis.html"),
        title: "Guidelines for Psychoacoustic Analysis",
        moduleType: WorkflowModuleType.Help,
        relevantWorkflowModes: ProductSoundDesignWorkflowModes,
        topicParent: PsychoacousticsGuidanceCatalog.PsychoacousticsOverviewModule,
        topicType: GuidanceTopicType.Question,
        topicContent: "How to set up for Psychoacoustic Analysis?",
        catchwords: ["psychoacoustics", "measurement", "analysis", "setup", "guidelines"],
    };
}
